import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import HighlightOff from '@material-ui/icons/HighlightOffTwoTone';

const styles = theme => ({
  root: theme.buttonTypes != null ? {
    color: theme.buttonTypes.remove.backgroundColor,
    '&:hover': {
      color: theme.buttonTypes.remove['&:hover'].backgroundColor,
    },
  } : {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.getContrastText(theme.palette.secondary.main),
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
});

const NoCircleIcon = (props) => {
  const { disabled, classes, ...others } = props;

  if (disabled) {
    return <HighlightOff color="disabled" {...others} />;
  }

  return <HighlightOff classes={{ root: classes.root }} {...others} />;
};

NoCircleIcon.defaultProps = {
  disabled: false,
};

NoCircleIcon.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  disabled: PropTypes.bool,
};


export default withStyles(styles)(NoCircleIcon);
